import { Observable, of } from 'rxjs';
import { UpdateUserLanguageRequest } from '../../core-data-model/update-user-language-request';
import { UserAccessResponse } from '../../core-data-model/user-access-response';
import { UserProfileRequest } from '../../core-data-model/UserProfileRequest';
import { UserProfileApi } from './user-profile-api.connnect';

const getMock: () => Partial<UserProfileApi> = () => ({
    getUserProfileInfo(): Observable<UserProfileRequest> {
        return of(null);
    },

    updateUserProfileInfo(
        request: UserProfileRequest
    ): Observable<UserProfileRequest> {
        return of(null);
    },

    updateUserLanguage(
        request: UpdateUserLanguageRequest
    ): Observable<UserAccessResponse> {
        return of({
            results: {
                '123-123': {
                    identifier: '12345',
                    messages: ['Language updated successfully'],
                    isSuccess: true
                }
            },
            hasFailure: false,
            getErrors: []
        } satisfies UserAccessResponse);
    }
});

export const userProfileApiMock = {
    getMock,
    provider: (Service: typeof UserProfileApi) => ({
        provide: Service,
        useValue: getMock()
    })
};
